import { SVGProps, Ref, forwardRef } from 'react';

export const WalletOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22.2 13c0 1.736-.065 2.968-.235 3.87-.166.884-.402 1.272-.613 1.482s-.598.447-1.482.613c-.902.17-2.134.235-3.87.235H8c-1.736 0-2.968-.065-3.87-.235-.884-.166-1.272-.402-1.482-.613s-.447-.598-.614-1.482c-.17-.902-.234-2.134-.234-3.87v-2q0-.645.013-1.2h6.386c.667 1.587 1.863 2.7 3.801 2.7s3.134-1.113 3.802-2.7h6.386q.012.555.012 1.2zm-.113-5q-.047-.48-.122-.87c-.166-.884-.402-1.272-.613-1.482s-.598-.447-1.482-.613c-.902-.17-2.134-.235-3.87-.235H8c-1.736 0-2.968.065-3.87.235-.884.166-1.272.402-1.482.613s-.447.598-.614 1.482q-.073.39-.122.87H9.52c.126.587.307 1.1.538 1.516.434.782 1.002 1.184 1.942 1.184s1.508-.402 1.942-1.184c.231-.415.412-.93.539-1.516zM24 11v2c0 7-1 8-8 8H8c-7 0-8-1-8-8v-2c0-7 1-8 8-8h8c7 0 8 1 8 8"
                fill="currentColor"
            />
        </g>
    </svg>
));
WalletOutlinedSize24Glyph.displayName = 'WalletOutlinedSize24Glyph';
